import Vue from 'vue'
import App from './App'
import vuex from 'vuex'
import Meta from 'vue-meta'
import store from './vuex/store'
import VueRouter from 'vue-router'
import router from './router/index'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui' 
import './assets/font/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';

// import authM from './auth'
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(vuex);
Vue.use(Meta);
import less from 'less'
Vue.use(less)

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium'
  // i18n: (key, value) => i18n.t(key, value)
})


//跳转前设置title
router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo)
    store.commit("CAHNGE_META_INFO", to.meta.metaInfo);
  // window.document.title = to.meta.title;
  next();
});
//跳转后设置scroll为原点
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


Vue.prototype.NAVINFO =router.options.routes;
Vue.prototype.$win = window;
Vue.prototype.$localStorage = window.localStorage;
Vue.prototype.$sesionStorage = window.sessionStorage;

Storage.prototype.setExpire = (key, value, expire) => {
  let obj = {
    data: value,
    time: Date.now(),
    expire: expire
  };
  //localStorage 设置的值不能为对象,转为json字符串
  localStorage.setItem(key, JSON.stringify(obj));
}

Storage.prototype.getExpire = key => {
  let val = localStorage.getItem(key);
  if (!val) {
    return val;
  }
  val = JSON.parse(val);
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key);
    return null;
  }
  return val.data;
}


new Vue({
  el: '#app',
  router,
  store,
  extraHeaders: {"Access-Control-Allow-Origin": '*'},
  components: { App },
  template: '<App/>',
  metaInfo(){
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords
        }, {
          name: "description",
          content: this.$store.state.metaInfo.description
        }
      ]
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js